import { styled } from "@mui/material";
import Link from "@mui/material/Link";

interface StyledLinkProps {
  isDisabled?: boolean;
}

const StyledLink = styled(Link)<StyledLinkProps>`
  text-decoration: underline;
  text-underline-offset: 4px;
  font-size: ${(props) => props.theme.wsc.typography.body1bold.fontSize};
  font-weight: ${(props) => props.theme.wsc.typography.body1bold.fontWeight};
  cursor: ${(props) => (props.isDisabled ? "not-allowed" : "pointer")};
  color: ${(props) =>
    props.isDisabled
      ? props.theme.wsc.palette.neutral[300]
      : props.theme.wsc.palette.primary[300]};

  &:hover {
    color: ${(props) =>
      !props.isDisabled && props.theme.wsc.palette.primary[100]};
  }
`;

export default StyledLink;
